// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"84d74dc2","20":"84d74dc2","50":"b524e988","502":"98baee7f","581":"84d74dc2","726":"84d74dc2"}[chunkId] + ".chunk.css";
};